export default {
  showMore: {
    id: 'admin_tools_product_rematch_search_facet_more',
    defaultMessage: 'Show more',
  },
  showLess: {
    id: 'admin_tools_product_rematch_search_facet_less',
    defaultMessage: 'Show less',
  },
  nameAndCount: {
    id: 'admin_tools_product_rematch_search_facet_name_and_count',
    defaultMessage: '{name} - ({count})',
  },
}
